import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import AdminDashboardLayout from "../../../layouts/admin_dashboard_layout/admin_dashboard_layout";
import UploadDeaneryMemberTab from "./upload_deanery_member_tab";
import ManageDeaneryMembersTab from "./manage_deanery_members_tab";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`deanery-members-tabpanel-${index}`}
      aria-labelledby={`deanery-members-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function DeaneryMembersAdminPage() {
  const [currentTab, setCurrentTab] = useState(0);

  return (
    <AdminDashboardLayout>
      <Box flex={1} mt={2} mx={2}>
        <Card sx={{ borderRadius: 1, m: 3 }} elevation={1}>
          <CardContent>
            <Typography variant="h5" fontWeight="600" mb={2}>
              Deanery Members Management
            </Typography>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={currentTab}
                onChange={(_, newValue) => setCurrentTab(newValue)}
                aria-label="deanery members management tabs"
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab label="Add Member" id="deanery-members-tab-0" />
                <Tab label="Manage Members" id="deanery-members-tab-1" />
              </Tabs>
            </Box>

            <TabPanel value={currentTab} index={0}>
              <UploadDeaneryMemberTab onSuccess={() => setCurrentTab(1)} />
            </TabPanel>

            <TabPanel value={currentTab} index={1}>
              <ManageDeaneryMembersTab />
            </TabPanel>
          </CardContent>
        </Card>
      </Box>
    </AdminDashboardLayout>
  );
}

